var id = 0;

function generateId() {
  return ++id;
}

function useId() {
  return generateId();
}

export { useId };
//# sourceMappingURL=use-id.esm.js.map
